import React, { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Carousel from "../../Carousel";
import RecoverySection from "../../Recovery";
import Portfolio from "../../Portfolio";
import { counters } from "../../Constants/Counters";

const BinaPayasarBazar = () => {
  useEffect(() => {
    // Initialize Bootstrap carousel
    const carouselElement = document.getElementById("hero-carousel");
    if (carouselElement) {
      new window.bootstrap.Carousel(carouselElement);
    }
  }, []);

  const bannersItems = [

    {
      img: "/assets/img/m-bpd/S-7.jpg",
      // title: "Title 5",
      // description: "Description for image 5.",
    },

  ];

  const portfolioImage = [
    {
      img: "/assets/img/m-bpd/G-1.jpg",
      title: "A Heartwarming Distribution: Bina Paysar Bazar in Action",
      description:
       " At Bina Paysar Bazar, our volunteers joyfully distribute warm clothing to senior women in need. Each smile and grateful heart reflects the community spirit fostered by Mallabhum Prayas. Together, we ensure that everyone feels the warmth of compassion, making a meaningful impact in their lives this winter.",
    },
    {
      img: "/assets/img/m-bpd/G-2.jpg",
      title: "Preparing with Care: Bina Paysar Bazar",
      description:
        "Volunteers at Bina Paysar Bazar diligently sort through donated clothing, ensuring that warm garments are ready for distribution. Their efforts embody compassion and commitment to supporting underprivileged community members.",
    },
    {
      img: "/assets/img/m-bpd/G-3.jpg",
      title: "Joyful Giving: Bina Paysar Bazar",
      description:
        "At Bina Paysar Bazar, our volunteers distribute warm clothing to eager little boys and girls waiting in line. Their smiles reflect hope and gratitude, showcasing the power of community support.",
    },
    {
      img: "/assets/img/m-bpd/G-4.jpg",
      title: "Empowering Generations: Bina Paysar Bazar",
      description:
        "Volunteers at Bina Paysar Bazar distribute warm clothing to women and elderly superwomen waiting in line. Their smiles and gratitude highlight the community's commitment to supporting those in need.",
    },
    // {
    //   img: "assets/img/m-bpd/G-5.jpg",
    //   title: "Feeding the Future: A Community Effort",
    //   description:
    //     "Our volunteers are the heart of the Zero Waste Food initiative, collecting leftover food and delivering it to families in need. Together, we are building a stronger, more compassionate community.",
    // },
    // {
    //   img: "assets/img/m-bpd/G-6.jpg",
    //   title: "Sustaining Lives: The Power of Community",
    //   description:
    //     "Through the efforts of our volunteers, excess food is transformed into hope. We collect and distribute meals to those in need, proving that together, we can create a sustainable future.",
    // },
    // {
    //   img: "assets/img/m-bpd/G-7.jpg",
    //   title: "From Celebration to Compassion",
    //   description:
    //     "Witness the journey of excess food from joyous occasions to those in need. Our volunteers work tirelessly to collect and distribute meals, transforming celebrations into acts of generosity",
    // },
    // {
    //   img: "assets/img/m-bpd/G-8.jpg",
    //   title: "Gathering Generosity: Volunteers Collecting Food",
    //   description:
    //     "Our passionate volunteers are hard at work, collecting surplus food from various events. Their dedication not only reduces waste but also ensures that nutritious meals are shared with those in need. Together, we are making a meaningful impact in our community!",
    // },
  ];
  return (
    <main className="main">
      <Carousel bannersItems={bannersItems} />
      <RecoverySection
        counters={[counters[6]]}
        title="THOSE WHO STILL CAN'T DREAM"
      />
      <Portfolio
        portfolioHeader="Bina Paysar Bazar: A Noble Initiative by Mallabhum Prayas"
        description="Bina Paysar Bazar is a commendable initiative launched by Mallabhum Prayas, aimed at addressing the pressing needs of underprivileged communities. This unique project focuses on the collection and distribution of gently used clothing, particularly winter wear, to those who are less fortunate and often struggle to meet their basic needs.

        The essence of Bina Paysar Bazar lies in its community-driven approach. Members of Mallabhum Prayas actively gather various types of clothing that are still in good condition, ensuring that they can be reused rather than discarded. This not only promotes sustainability but also fosters a sense of solidarity among community members. By encouraging individuals to donate their surplus clothing, the initiative helps to create a culture of giving and compassion.

        Once collected, the clothing is sorted and distributed to families in need, particularly during the colder months when warm clothing is essential for survival. The initiative has a profound impact on the lives of many, providing them with not just physical warmth but also a sense of dignity and hope. The act of receiving clothing from the community reinforces the idea that they are not alone in their struggles; rather, they are supported by a network of caring individuals.

        Bina Paysar Bazar exemplifies how grassroots initiatives can make a significant difference in society. It highlights the importance of community involvement in addressing social issues and encourages others to take similar steps in their own neighborhoods. By bridging the gap between those who have and those who need, Mallabhum Prayas is not only providing essential resources but also nurturing a spirit of empathy and cooperation. Through Bina Paysar Bazar, the organization continues to inspire positive change, one piece of clothing at a time."
        portfolioImage={portfolioImage}
      />
    </main>
  );
};

export default BinaPayasarBazar;
